<div
  class="app-footer"
  [ngClass]="{ scorm: type === 'scorm', campus: type === 'campus', payment: type === 'payment' }"
>
  <div class="app-footer__logo"></div>
  <span>© Gamelearn {{ utilsService.getYear() }}</span>
</div>
